import {PayServicesPage} from './PayServicesPage';
export default PayServicesPage;